import React, { useCallback } from 'react';
import { Send } from '@material-ui/icons';
import { isMobile } from 'react-device-detect';
import classnames from 'classnames';

import './css/BroadcastChatInput.css';
import './css/BroadcastChatInput.mobile.css';
import 'emoji-mart/css/emoji-mart.css';

import BroadcastChatInputEmoticonPicker from './BroadcastChatInputEmoticonsPicker';


const BroadcastChatInput = ({
  inputMessage,
  updateInputMessage,
  onInputKeyPress,
  onMessageSend,
  onEmoticonPicked,
}) => {
  const inputRef = React.useRef(null);
  const [emoticonsPickerVisible, toggleEmoticonsPicker] = React.useState(false);
  const onEmoticonClick = React.useCallback((emoticon) => {
    onEmoticonPicked(emoticon);
    if (!isMobile) {
      inputRef.current.focus();
    }
  });

  const onLocalInputKeyPress = React.useCallback((event) => {
    if (event.key === 'Enter') {
      toggleEmoticonsPicker(false);
    }
    onInputKeyPress(event);
  });

  const onLocalSendButtonClick = React.useCallback((event) => {
    onMessageSend(event);
    toggleEmoticonsPicker(false);
  });

  const shouldMinimizeInputArea = useCallback(() => {
    if (inputMessage.length < 18) {
      return true;
    }

    return false;
  }, [inputMessage]);

  return (
    <div className="broadcast-chat-input-container">
      {!isMobile && (
        <BroadcastChatInputEmoticonPicker
          emoticonsPickerVisible={emoticonsPickerVisible}
          toggleEmoticonsPicker={toggleEmoticonsPicker}
          onEmoticonClick={onEmoticonClick}
        />
      )}
      <div className="send" onClick={onLocalSendButtonClick}>
        <Send fontSize="large" />
      </div>
      <textarea
        ref={inputRef}
        className={classnames({
          'broadcast-chat-input': true,
          'chat-input-minimize': shouldMinimizeInputArea(),
        })}
        maxLength={80}
        placeholder="Type something..."
        type="text"
        value={inputMessage}
        onChange={updateInputMessage}
        onKeyPress={onLocalInputKeyPress}
      />
    </div>
  );
};

export default BroadcastChatInput;
